/** @format */

import React from "react";
import AccountsOverview from "./AccountsOverview";
import { Tabs } from "antd";
import ChartsContainer from "./Charts/Charts.container";
import PhoneNumbersOverview from "./PhoneNumbersOverview";
import AsrChartsContainer from "./Charts/AsrCharts/AsrCharts.container";
import SpeechAnalyticsPage from "./SpeechAnalyticsPage/SpeechAnalyticsPage"
import type { TabsProps } from "antd";

interface IRegistrationFormProps {
	sitekey: string;
	onSuccess: () => void;
}

const MainContentView: React.FC<IRegistrationFormProps> = ({
	sitekey,
	onSuccess,
}) => {
	const tabsArray: TabsProps["items"] = [
		{
			key: "1",
			label: "Accounts",
			children: <AccountsOverview sitekey={sitekey} onSuccess={onSuccess} />,
		},
		{
			key: "2",
			label: "Phone Numbers",
			children: <PhoneNumbersOverview />,
		},
		{
			key: "3",
			label: "Account Activity",
			children: <ChartsContainer />,
		},
		{
			key: "4",
			label: "API Use",
			children: <AsrChartsContainer />,
		},
		{
			key: "5",
			label: "Speech Analytics",
			children: <SpeechAnalyticsPage />,
		},
	];

	return (
		<div style={{ paddingLeft: "10px" }}>
			<Tabs defaultActiveKey="1" items={tabsArray} />
		</div>
	);
};

export default MainContentView;
